import React, { useState, createContext } from 'react';
import { noop } from '@/utils';

type SurveysContextProps = {
  searchFilterQuery: string;
  setSearchFilterQuery: (searchFilterQuery: string) => void;
};

// SurveysContext context
export const SurveysContext = createContext<SurveysContextProps>({
  searchFilterQuery: '',
  setSearchFilterQuery: noop,
});

// SurveysProvider context provider
export const SurveysContextProvider = ({ children }: { children?: any }) => {
  const [searchFilterQuery, setSearchFilterQuery] = useState<string>('');

  return (
    <SurveysContext.Provider value={{ searchFilterQuery, setSearchFilterQuery }}>
      {children}
    </SurveysContext.Provider>
  );
};
